import CLFiles, { LogLevelName } from "@cloudike/web_files"
import { USER_DATA_KEY_IN_STORAGE } from "features/user/constants"

import { getCurrentAppConfig, getCurrentAppConfigApiHost } from "../features/common/configs/additionalConfigService"

import { WebSocketService } from "./webSocketService"
import { getSdkWS } from "./sdkWS"

const options = {
  logLevel: LogLevelName.TRACE
}

let filesWS: WebSocketService

const getConfig = () => {
  const wsConfig = {
    sockjs: getCurrentAppConfig().sockjs,
    websocket_event_groups: [
      "fs",
      "fs2",
      "photos",
      "family"
    ],
  }

  return {
    authToken: localStorage.getItem(USER_DATA_KEY_IN_STORAGE) && JSON.parse(`${localStorage.getItem(USER_DATA_KEY_IN_STORAGE)}`)?.CurrentUser?.token,
    baseUrl: getCurrentAppConfigApiHost(),
    userAgent: `web-client ${process.env.APP_VERSION}`,
    wsConfig
  }
}

export const getFilesSdk = (): CLFiles => {
  let sdk = null

  try {
    sdk = CLFiles.init(options, getConfig())
  } catch (e) {
    console.error(`Couldn't init photos sdk`, e)
  }

  return sdk
}

export const getFilesWS = () => {
  if (filesWS) {
    return filesWS
  }

  const sdk = getFilesSdk()
  const ws = getSdkWS(sdk)

  filesWS = new WebSocketService(ws, true)

  return filesWS
}
